import React from "react";

const NavigationContext = React.createContext({});
NavigationContext.displayName = "NavigationContext";

export { NavigationContext };
